import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Hero.css";

import kemaribotbg  from "../../assets/kemaribotbg.png";
import highlights1  from "../../assets/projectsimgs/llcAdmin4.png";
import highlights3  from "../../assets/featuredimgs/highlights2.png";
import highlights4  from "../../assets/featuredimgs/highlights4.png";

import P1 from "../../assets/partnersimgs/partner1.png";
import P2 from "../../assets/partnersimgs/partner2.png";
import P3 from "../../assets/partnersimgs/partner3.png";
import P4 from "../../assets/partnersimgs/partner4.png";
import P5 from "../../assets/partnersimgs/partner5.png";
import P6 from "../../assets/partnersimgs/partner6.png";

import GetStarted from "./GetStarted";

const BG_IMAGES     = [kemaribotbg, highlights1, highlights3, highlights4].filter(Boolean);
const PARTNER_LOGOS = [P1, P2, P3, P4, P5, P6];
const PARTNERS_LOOP = [...PARTNER_LOGOS, ...PARTNER_LOGOS];

function Hero() {
  // Track the "current" and "next" layer indices + which layer is on top
  const [layers, setLayers]             = useState({ a: 0, b: 1, top: "a" });
  const [showGetStarted, setShowGetStarted] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  /* Preload */
  useEffect(() => {
    BG_IMAGES.forEach((src) => { const img = new Image(); img.src = src; });
  }, []);

  /* Crossfade carousel */
  useEffect(() => {
    if (BG_IMAGES.length < 2) return;

    const t = setInterval(() => {
      setLayers((prev) => {
        const nextIndex = (
          (prev.top === "a" ? prev.a : prev.b) + 1
        ) % BG_IMAGES.length;

        if (prev.top === "a") {
          // Load next image into layer b, then bring b to top
          return { ...prev, b: nextIndex, top: "b" };
        } else {
          // Load next image into layer a, then bring a to top
          return { ...prev, a: nextIndex, top: "a" };
        }
      });
    }, 5000);

    return () => clearInterval(t);
  }, []);

  const handleExplore = () => {
    if (location.pathname !== "/") {
      navigate("/#projects");
    } else {
      document.getElementById("projects")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="hero-section" className="hero">

      {/* ── CROSSFADE BACKGROUND LAYERS ── */}
      <div
        className="hero-bg-layer"
        style={{
          backgroundImage: `url(${BG_IMAGES[layers.a]})`,
          opacity: layers.top === "a" ? 1 : 0,
        }}
      />
      <div
        className="hero-bg-layer"
        style={{
          backgroundImage: `url(${BG_IMAGES[layers.b]})`,
          opacity: layers.top === "b" ? 1 : 0,
        }}
      />

      <div className="hero-dark-overlay" />

      {/* ── MAIN CONTENT ── */}
      <div className="hero-content">
        <h1 className="hero-title">
          Your <em>trusted partner</em> in<br />
          auxiliary and security solutions
        </h1>

        <p className="hero-description">
          We build reliable technology infrastructures that keep your
          business secure, organized, and running smoothly.
        </p>

        <div className="hero-buttons">
          <button className="hero-btn-secondary" onClick={handleExplore}>
            Explore Projects
          </button>
          <button className="hero-btn" onClick={() => setShowGetStarted(true)}>
            Get Started
          </button>
        </div>

        <div className="hero-partners-row">
          <div className="partners-section">
            <div className="partners-track">
              {PARTNERS_LOOP.map((img, i) => (
                <div className="partner-logo" key={i}>
                  <img src={img} alt="partner" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {showGetStarted && (
        <div className="getstarted-overlay">
          <button
            className="close-getstarted"
            onClick={() => setShowGetStarted(false)}
            aria-label="Close"
          >
            ✕
          </button>
          <GetStarted />
        </div>
      )}
    </section>
  );
}

export default Hero;